export class ResendLink {
    constructor(
        public email: string        
    ) { }
}
